/**
 * Page contains the whole login form, it's small enough not to be separated.
 */
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import t from "../service/translate.service";
import PrimaryTitle from "../components/PrimaryTitle";
import LoginRegisterSwitcher from "../components/LoginRegisterSwitcher";
import { useMsal } from "@azure/msal-react";
import { b2cPolicies } from "../azureB2C/authConfig";
import LoadingPageOverlay from "../components/LoadingPageOverlay";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { useTheme } from "../providers/ThemeProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import MagicLinkStore from "../store/magicLink.store";

const RegistrationPage = () => {
  const { instance } = useMsal();
  const magicLinkStore = new MagicLinkStore()
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const language = localStorage.getItem("locale") || "de";
  const { activeMagnifier } = useTheme()
  const [searchParams, setSearchParams] = useSearchParams();
  const [registrationAdditionalInfo, setRegistrationAdditionalInfo] = useState({})

  const proceedTokenHandler = async (count = 0) => {
    try {
      const proceedToken = searchParams.get('proceedToken')
      if (proceedToken) {
        const proceedTokenData = localStorage.getItem('contractSigningFeatureProceedToken') ? JSON.parse(localStorage.getItem('contractSigningFeatureProceedToken')) : ''
        switch (proceedTokenData?.type) {
          case 'contractSigningFeature':
            setRegistrationAdditionalInfo({
              state: JSON.stringify({
                activateEmail: true,
                contractCreation: true,
                contractSignId: proceedTokenData?.contractSignId || ''
              }),
              firstName: proceedTokenData?.firstName ? encodeURIComponent(proceedTokenData?.firstName) : '',
              lastName: proceedTokenData?.lastName ? encodeURIComponent(proceedTokenData?.lastName) : '',
              email: proceedTokenData?.email ? encodeURIComponent(proceedTokenData?.email) : '',
              phone: proceedTokenData?.phone ? encodeURIComponent(proceedTokenData.phone) : '',
              type: proceedTokenData?.type ? encodeURIComponent(proceedTokenData?.type) : ''
            })
            break;
          default:
            setRegistrationAdditionalInfo({})
            throw new Error('MAGIC_LINK_WRONG_TYPE')
        }
      }
    } catch (err) {
      console.log(err)
      if (count < 3) {
        proceedTokenHandler(count + 1)
      } else {
        setRegistrationAdditionalInfo({})
        navigate('/login')
      }
    }
  }

  useEffect(() => {
    (async () => {
      setTimeout(() => {
        setLoading(true);
        proceedTokenHandler()
        setLoading(false);
      }, 1000)
    })()
  }, [])

  const handleEmailRegister = async () => {
    localStorage.removeItem('path')
    setLoading(true);
    try {
      await instance.acquireTokenRedirect({
        ...b2cPolicies.authorities.emailSignUp,
        ...( registrationAdditionalInfo?.state ? { state: registrationAdditionalInfo?.state } : {}),
        extraQueryParameters: {
          ui_locales: `${language}`,
          magnifier: activeMagnifier.value,
          ...( registrationAdditionalInfo?.firstName ? { firstName: registrationAdditionalInfo?.firstName } : {}),
          ...( registrationAdditionalInfo?.lastName ? { lastName: registrationAdditionalInfo?.lastName } : {}),
          ...( registrationAdditionalInfo?.email ? { email: registrationAdditionalInfo?.email } : {}),
          ...( registrationAdditionalInfo?.phone ? { phone: registrationAdditionalInfo?.phone } : {}),
          ...( registrationAdditionalInfo?.type ? { type: registrationAdditionalInfo?.type } : {})
        },
      });
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const handleGoogleRegister = async () => {
    setLoading(true)
    const savedPath = localStorage.getItem('path')
    localStorage.removeItem('path')
    try {
      await instance.acquireTokenRedirect({
        ...b2cPolicies.authorities.googleSignUpSignIn,
        ...( registrationAdditionalInfo?.state ? { state: registrationAdditionalInfo?.state } : {}),
        extraQueryParameters: {
          'ui_locales': `${language}`,
          magnifier: activeMagnifier.value,
          ...( registrationAdditionalInfo?.firstName ? { firstName: registrationAdditionalInfo?.firstName } : {}),
          ...( registrationAdditionalInfo?.lastName ? { lastName: registrationAdditionalInfo?.lastName } : {}),
          ...( registrationAdditionalInfo?.email ? { email: registrationAdditionalInfo?.email } : {}),
          ...( registrationAdditionalInfo?.phone ? { phone: registrationAdditionalInfo?.phone } : {}),
          ...( registrationAdditionalInfo?.type ? { type: registrationAdditionalInfo?.type } : {})
        },
        redirectStartPage: savedPath || '/'
      })
    } catch(err) {
      console.log(err)
    }
    setLoading(false)
  }

  const handleAppleRegister = async () => {
    setLoading(true)
    const savedPath = localStorage.getItem('path')
    localStorage.removeItem('path')
    try {
      await instance.acquireTokenRedirect({
        ...b2cPolicies.authorities.appleSignUpSignIn,
        ...( registrationAdditionalInfo?.state ? { state: registrationAdditionalInfo?.state } : {}),
        extraQueryParameters: {
          'ui_locales': `${language}`,
          magnifier: activeMagnifier.value,
          ...( registrationAdditionalInfo?.firstName ? { firstName: registrationAdditionalInfo?.firstName } : {}),
          ...( registrationAdditionalInfo?.lastName ? { lastName: registrationAdditionalInfo?.lastName } : {}),
          ...( registrationAdditionalInfo?.email ? { email: registrationAdditionalInfo?.email } : {}),
          ...( registrationAdditionalInfo?.phone ? { phone: registrationAdditionalInfo?.phone } : {}),
          ...( registrationAdditionalInfo?.type ? { type: registrationAdditionalInfo?.type } : {})
        },
        redirectStartPage: savedPath || '/'
      })
    } catch(err) {
      console.log(err)
    }
    setLoading(false)
  }

  if (loading) {
    return <LoadingPageOverlay />;
  }

  return (
    <div>
      <PrimaryTitle title={t.WELCOME_TITLE} />
      <LoginRegisterSwitcher />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <Button
          style={{
            width: language === "en" ? "254px" : "247px",
            justifyContent: "center",
          }}
          onClick={() => handleEmailRegister()}
          className="button primary"
          aria-label={t.LOGIN_PAGE_REGISTER_WITH_EMAIL}
        >
          {t.LOGIN_PAGE_REGISTER_WITH_EMAIL}
        </Button>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            marginTop: "12px",
            marginBottom: "12px",
          }}
          role="separator"
          aria-label={t.LOGIN_PAGE_REGISTER_OR}
        >
          <div
            style={{
              width: "80px",
              height: "1px",
              backgroundColor: "#acadae",
            }}
          ></div>
          <p
            style={{
              marginBottom: "1px",
            }}
            aria-hidden="true"
          >
            {t.LOGIN_PAGE_REGISTER_OR}
          </p>
          <div
            style={{
              width: "80px",
              height: "1px",
              backgroundColor: "#acadae",
            }}
          ></div>
        </div>
        <Button
          style={{
            width: language === "en" ? "254px" : "247px",
            justifyContent: "center",
          }}
          onClick={() => handleGoogleRegister()}
          className="button google"
          aria-label={t.LOGIN_PAGE_REGISTER_WITH_GOOGLE}
        >
          <FcGoogle aria-hidden="true" />
          {t.LOGIN_PAGE_REGISTER_WITH_GOOGLE}
        </Button>
        <Button
          style={{
            width: language === "en" ? "254px" : "247px",
            justifyContent: "center",
          }}
          onClick={() => handleAppleRegister()}
          className="button apple"
          aria-label={t.LOGIN_PAGE_REGISTER_WITH_APPLE_ID}
        >
          <FaApple aria-hidden="true" />
          {t.LOGIN_PAGE_REGISTER_WITH_APPLE_ID}
        </Button>
      </div>
    </div>
  );
};

export default RegistrationPage;
